import type { PaymentMethod } from '../../db/types';
import type { ReceiptAddOnLine, ReceiptData } from './receiptTypes';

export function getReceiptPayment(data: ReceiptData) {
  const payment = data.payments[0];
  const amountPaidCentavos = payment?.amountCentavos ?? 0;
  const changeCentavos =
    payment?.method === 'CASH' ? Math.max(0, amountPaidCentavos - data.order.totalCentavos) : 0;
  return { payment, amountPaidCentavos, changeCentavos };
}

export function paymentLabel(method?: PaymentMethod): string {
  if (!method) return 'UNPAID';
  return method === 'GCASH' ? 'GCASH' : method === 'MAYA' ? 'MAYA' : 'CASH';
}

export function formatReceiptDate(value: string): string {
  return new Intl.DateTimeFormat('en-PH', {
    timeZone: 'Asia/Manila',
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value));
}

export function getReceiptAddOnLines(items: ReceiptData['items']): ReceiptAddOnLine[] {
  const lines: ReceiptAddOnLine[] = [];
  const legacySeen = new Set<string>();

  for (const item of items) {
    for (const selection of item.addonSelections ?? []) {
      lines.push({
        key: `${item.id}:${selection.addonId}`,
        addonId: selection.addonId,
        nameSnapshot: selection.nameSnapshot,
        quantity: selection.quantity,
        unitPriceCentavos: selection.unitPriceCentavos,
        lineTotalCentavos: selection.lineTotalCentavos,
      });
    }

    if ((item.addonSelections?.length ?? 0) > 0) continue;
    for (const [index, nameSnapshot] of (item.addOnNames ?? []).entries()) {
      const addonId = item.addOnIds?.[index];
      const legacyKey = addonId ?? nameSnapshot;
      if (legacySeen.has(legacyKey)) continue;
      legacySeen.add(legacyKey);
      lines.push({
        key: `legacy:${legacyKey}`,
        addonId,
        nameSnapshot,
        quantity: 1,
      });
    }
  }

  return lines;
}
